import React, { Component } from 'react'
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import COLORS from '../resources/colors/COLORS';
import SessionManager from '../Utils/SessionManager';
import {BrowserRouter as Router,Link, Redirect, Route } from 'react-router-dom';
import '../css/Admin_css/admin-customize.css';
import myToast from '../Utils/MyToast';
import Iframe from 'react-iframe'
export default class PrintableDocsBlank extends Component {
 
     
  constructor(props){
            super(props)
        
            const token=localStorage.getItem("token");
            let loggedIn=true;
            if(token==null){
              loggedIn=false;
            }
        
            this.state={
        
                loggedIn:true,
                Loading:false, 
                isOpenSelectStudent:false,
                showStudentIdCard:false,
                Total:0,
                mSelectedStudent:[],
                mPrintableSamples:[],
                mColorOption:[],
                iFrameHeight:'0px',
                SELECTED_SAMPLE_ID:'',
                SELECTED_SAMPLE_POSITION:0,
                SELECTION_TYPE:'',
                FILE_URL:'',
                FILE_NAME:'',
                FILE_DIRECTORY:'',
                DOCUMENT_TYPE:'',
                COLOR_OPTION_ID:''

            }
           
        }
       
        componentDidMount()
        {
          this.state.DOCUMENT_TYPE=this.props.match.params.document_type;
          
          this.getPrintableSamples();
        }
        getPrintableSamples(){
          this.setState({
            Loading:true
          })
         
          const SCHOOL_CODE=SessionManager.getSchoolCode();
          const FUNCTION_NAME='getPrintableSample.php?';
          URL=process.env.REACT_APP_SERVER_NAME+process.env.REACT_APP_TARGET_DIR+FUNCTION_NAME;
         // alert(URL);
          console.log("URL>>>>>"+URL);

          axios.get(URL,{
            params:{
              school_code:SCHOOL_CODE,
              document_type:this.state.DOCUMENT_TYPE,
              
            }
          }).then(res => res.data)
          .then((response) => {
           
            this.setState({ 
              Loading:false
             })
             // console.log("Response2>>>>>"+response);
              let api_status=response.api_status;
              //alert(JSON.stringify(response));
             
              if(api_status=="OK")
              {
              
                 this.setState({
                    mPrintableSamples:response.data,
                   
                  })
                 // alert("mPrintableSamples>>>>>"+JSON.stringify(this.state.mPrintableSamples));
                  this.setSample(this.state.SELECTED_SAMPLE_POSITION);
               
              }
              else{
                let api_remark=response.api_remark;
                myToast.notify_warning(api_remark);
              }
           }).catch((error)=>{
            this.setState({ 
              Loading:false
             })
            console.log("error>>>>>"+error);
            });
        
          }
          setSample(selected_sample_position){
           
            var sample_id=this.state.mPrintableSamples[selected_sample_position].sample_id;
            this.state.FILE_NAME=this.state.mPrintableSamples[selected_sample_position].file_name;
            this.state.FILE_DIRECTORY=this.state.mPrintableSamples[selected_sample_position].file_directory;
            this.state.SELECTED_SAMPLE_ID=sample_id;
           // alert(  this.state.SELECTED_SAMPLE_ID);

            this.getColorOptions(selected_sample_position);
             
  }
  getColorOptions (selected_sample_position)
  {
    
      this.state.mColorOption=[];
      this.state.mColorOption=this.state.mPrintableSamples[selected_sample_position].color_options;
      this.setColorOptions(0);

  }  
  setColorOptions(selected_position_color_option)   
  {
    
    if(this.state.mColorOption!==null)
    {
      if(this.state.mColorOption.length==0)
      {
          this.state.COLOR_OPTION_ID="";
      }
      else{
        this.state.COLOR_OPTION_ID=this.state.mColorOption[selected_position_color_option].color_option_id;
      }
    }
    else{
      this.state.COLOR_OPTION_ID="";
    }

    this. setFileUrL();


  }   
  setFileUrL(){
   
    var session_id="";
    const SCHOOL_CODE=SessionManager.getSchoolCode();
  
    this.state.FILE_URL=process.env.REACT_APP_SERVER_NAME+this.state.FILE_DIRECTORY+this.state.FILE_NAME+'?&session_id='+JSON.stringify(session_id)+'&sample_id='+this.state.SELECTED_SAMPLE_ID+'&system_code='+process.env.REACT_APP_SYSTEM_CODE+'&color_option_id='+this.state.COLOR_OPTION_ID+'&school_code='+SCHOOL_CODE;
    console.log("FILE_URL",this.state.FILE_URL);
    // alert(this.state.FILE_URL);
    this.setState({
            
    });
  }        
          autoResize=()=>{
              alert("loaded");
              var iFrame = document.getElementById('iFrame1');
             
             
          }
        
          render() {
            if( this.state.loggedIn==false)
            {
             return <Redirect to='/Login'/>;
            }
            if(this.state.Loading)
            {
               return <MyLoader/>
            }
            else{
            return ( 
              
        
          <div className="content">
              <div className="content-header" style={{background:COLORS.primary_color_shade5}}>
                <div className="leftside-content-header">
                  <ul className="breadcrumbs">
                    <li><i className="fa fa-home" aria-hidden="true" style={{color:COLORS.white}} /><a href="#">{this.state.mPrintableSamples.length!=0? "Printable-"+this.state.mPrintableSamples[0].document_caption:"Printable"}</a></li>
                  </ul>
                </div>
              </div>  
              
          <div className="animated fadeInUpn bg_page_grey_rounded box_shadow" style={{'--mMargin':'50px'}}>
          <div className="row margin_10" style={{height:'120px'}}>
               
              <div className="col-sm-6 col-lg-6 padding_0 height_match_parent" data-toggle="modal" data-target="#exampleModal" onClick={this.HandleShow}>
                    <div className="bg_card_primary_outline  height_match_parent" style={{padding:'5px',color:'#fff',margin:'0px 5px 0px 0px'}}>                 
                      <div className="row">                        
                          <div className="col-sm-4 gravity_center padding_0">
                          <div className="rect_image_view" id="myStudentPicContainer">
                              <img src="<?php echo  $StudentData[$i]['student_img_path'] ;?>" class="img_logo" />
                          </div>
                          </div>
                          <div className="col-sm-8 gravity_center_vertical padding_0">
                              <div className="gravity_center_row ">
                                  <p className="margin_0" style={{color:'#000'}}> <b>Sample Name : </b></p>
                                  <p className="margin_0" style={{color:'#000'}}>{ this.state.mPrintableSamples.length!=0? this.state.mPrintableSamples[this.state.SELECTED_SAMPLE_POSITION].sample_name:''}</p>
                            </div>
                            <div className="gravity_center_row ">
                                  <p className="margin_0" style={{color:'#000'}}> <b>Sample Description : </b></p>
                                  <p className="margin_0" style={{color:'#000'}}>{ this.state.mPrintableSamples.length!=0? this.state.mPrintableSamples[this.state.SELECTED_SAMPLE_POSITION].sample_remark:''}</p>
                            </div>
                            <div className="gravity_center width_match_parent margin_5 padding_5" style={{width:'120px'}}>
                                  <button className="bg_card_primary btn btn-success">Change Sample</button>
                              </div>
                          </div>
                         

                      </div>
                     
                    </div>
              </div>

            </div>
            <div className="row" style={{margin:'0px 10px 0px 10px'}}>
                <h5 className="">Preview</h5>
            </div>

           
             
              <div className="row"  style={{margin:'0px 10px 0px 10px'}}>
              {this.state.showStudentIdCard ? <div><MyLoader/></div> 
                      
                      :''}                        
                <Iframe url={this.state.FILE_URL}
                        width="100%"
                        height="800px"
                        overflow="visible"
                        id="iFrameStudentId"
                        className="bg_card_primary_outline"
                        display="initial"
                        position="relative"
                        onLoad={() => {
                         
                          this.setState({
                            showStudentIdCard:false,
                            
                          })
                      }} 
                      />
                        
               
              </div> 
             
          </div>
       
               
         </div>
  
  )
}    
}
 
}